const LeadStageOptions = [
  {
    value: 'Untouched',
    display: 'Untouched'
  },
  {
    value: 'Unqualified',
    display: 'Unqualified'
  },
  {
    value: 'Not_Answering',
    display: 'Not Answering'
  },

  {
    value: 'Demo_Booked',
    display: 'Demo Booked'
  },
  {
    value: 'Demo_Not_Attended',
    display: 'Demo Not Attended'
  },
  {
    value: 'Demo_Attended',
    display: 'Demo Attended'
  },
  {
    value: 'In_Progress',
    display: 'In Progress'
  },
  {
    value: 'Call_Rejected',
    display: 'Call Rejected'
  },
  {
    value: 'Callback_Later',
    display: 'Callback Later'
  },
  {
    value: 'Not_Interested',
    display: 'Not Interested'
  },
  {
    value: 'Invalid_Number',
    display: 'Invalid Number'
  },
  {
    value: 'Registered',
    display: 'Registered'
  }
];

const LeadPipeline = {
  'UNTOUCHED': {
    display: 'Untouched',
    key: 'UNTOUCHED',
    leadStages: [LeadStageOptions.UNTOUCHED]
  },
  'NO_CONTACT': {
    display: 'No Contact',
    key: 'NO_CONTACT',
    leadStages: [LeadStageOptions.NOT_ANSWERING, LeadStageOptions.CALLBACK_LATER, LeadStageOptions.CALL_REJECTED]
  },
  'DEMO_BOOKED': {
    display: 'Demo Booked',
    key: 'DEMO_BOOKED',
    leadStages: [LeadStageOptions.DEMO_BOOKED]
  },
  'DEMO_NOT_ATTENDED': {
    display: 'Demo Not Attended',
    key: 'DEMO_NOT_ATTENDED',
    leadStages: [LeadStageOptions.DEMO_NOT_ATTENDED]
  },
  'PIPELINE': {
    display: 'Pipeline',
    key: 'PIPELINE',
    leadStages: [LeadStageOptions.DEMO_ATTENDED, LeadStageOptions.IN_PROGRESS]
  },
  'INVALID': {
    display: 'Invalid',
    key: 'INVALID',
    leadStages: [LeadStageOptions.UNQUALIFIED, LeadStageOptions.INVALID_NUMBER]
  },
  'REJECTED': {
    display: 'Rejected',
    key: 'REJECTED',
    leadStages: [LeadStageOptions.NOT_INTERESTED]
  }
};

const CallResult = [
  {
    value: 'NO_UPDATE',
    display: 'Select the call result'
  },
  {
    display: 'Not Answering',
    value: 'NOT_ANSWERING'
  },
  {
    value: 'ANSWERED',
    display: 'Answered'
  },
  {
    value: 'CALLBACK_LATER',
    display: 'Callback later'
  },
  {
    value: 'NOT_REACHABLE',
    display: 'Not Reachable'
  },
  {
    value: 'INVALID_NUMBER',
    display: 'Invalid Number'
  }
];

const ActionType = {
  types: [
    {
      key: 'PROFILE',
      display: 'Profile'
    },
    {
      key: 'CALL',
      display: 'Call'
    },
    {
      key: 'DEMO_BOOKED',
      display: 'Demo Booked'
    }
  ],
  keys: {
    'PROFILE': 'PROFILE',
    'CALL': 'CALL',
    'DEMO_BOOKED': 'DEMO_BOOKED'
  }
};

const IndustryOptions  = {
  options: [
    {
      key: 'UNKNOWN',
      display: 'Unknown'
    },
    {
      key: 'IT',
      display: 'IT'
    },
    {
      key: 'NON_IT_NON_ENGINEERING',
      display: 'Non IT Non Engineering'
    },
    {
      key: 'NON_IT_BUT_ENGINEERING',
      display: 'Non IT But Engineering'
    }
  ],
  keys: {
    'IT': 'IT',
    'NON_IT_NON_ENGINEERING': 'NON_IT_NON_ENGINEERING',
    'NON_IT_BUT_ENGINEERING': 'NON_IT_BUT_ENGINEERING'
  }
};

const ExperienceOptions = {
  options: [
    {
      key: 'UNKNOWN',
      display: 'Unknown'
    },
    {
      key: 'NO_EXPERIENCE',
      display: 'No Experience'
    },
    {
      key: 'ZERO_TO_ONE_YEAR',
      display: '0 to 1 year experience'
    },
    {
      key: 'ONE_TO_THREE_YEAR',
      display: '1 to 3 year experience'
    },
    {
      key: 'THREE_TO_SEVEN_YEAR',
      display: '3 to 7 year experience'
    },
    {
      key: 'MORE_THAN_SEVEN',
      display: 'More than 7 year experience'
    }
  ],
  keys: {
    'UNKNOWN': 'UNKNOWN',
    'NO_EXPERIENCE': 'NO_EXPERIENCE',
    'ZERO_TO_ONE_YEAR': 'ZERO_TO_ONE_YEAR',
    'ONE_TO_THREE_YEAR': 'ONE_TO_THREE_YEAR',
    'THREE_TO_SEVEN_YEAR': 'THREE_TO_SEVEN_YEAR',
    'MORE_THAN_SEVEN': 'MORE_THAN_SEVEN'
  }
};

const ProfessionOptions = {
  options: [
    {
      key: 'UNKNOWN',
      display: 'Unknown'
    },
    {
      key: 'FRESHER',
      display: 'Fresher'
    },
    {
      key: 'FRONTEND_DEVELOPER',
      display: 'Frontend Developer'
    },
    {
      key: 'BACKEND_DEVELOPER',
      display: 'Backend Developer'
    },
    {
      key: 'DATA_ANALYST',
      display: 'Data Analyst'
    },
    {
      key: 'OTHER',
      display: 'Other'
    }
  ],
  keys: {
    'UNKNOWN': 'UNKNOWN',
    'FRESHER': 'FRESHER',
    'FRONTEND_DEVELOPER': 'FRONTEND_DEVELOPER',
    'BACKEND_DEVELOPER': 'BACKEND_DEVELOPER',
    'DATA_ANALYST': 'DATA_ANALYST',
    'OTHER': 'OTHER'
  }
}

export { LeadStageOptions, LeadPipeline, ActionType, CallResult, ExperienceOptions, IndustryOptions, ProfessionOptions };
